import { render, staticRenderFns } from "./TestingChangeComments.vue?vue&type=template&id=f7897e72"
import script from "./TestingChangeComments.vue?vue&type=script&lang=ts"
export * from "./TestingChangeComments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports